var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "expand_contract--container" }, [
    _c(
      "h3",
      {
        attrs: { title: _vm.tooltip },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.expandContract.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "a",
          {
            staticClass: "expand_contract--title",
            attrs: { title: _vm.tooltip, href: "#" },
          },
          [
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isExpanded,
                    expression: "!isExpanded",
                  },
                ],
                staticClass: "expand_contract--icon_expand",
              },
              [
                _c("use", {
                  attrs: {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": "#symbol_arrow_down",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isExpanded,
                    expression: "isExpanded",
                  },
                ],
                staticClass: "expand_contract--icon_contract",
              },
              [
                _c("use", {
                  attrs: {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": "#symbol_arrow_up",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExpanded,
            expression: "isExpanded",
          },
        ],
        staticClass: "expand_contract--body",
      },
      [
        !_vm.similarRoomsHtml.length
          ? _c("div", [_vm._t("default")], 2)
          : _vm._e(),
        _vm._v(" "),
        _vm.similarRoomsHtml.length
          ? _c("div", { staticClass: "body-container page-links" }, [
              _c("div", { staticClass: "viewport" }, [
                _c("div", {
                  staticClass: "body-container-scroller",
                  domProps: { innerHTML: _vm._s(_vm.similarRoomsHtml) },
                  on: { click: _vm.similarRoomsClickHandler },
                }),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }